import {
  WalletsGemsClient,
  GemResponse,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const walletGemsClient = new WalletsGemsClient(
  apiConfig,
  undefined,
  axiosInstance
);

export const handleGetGemResponse = async (): Promise<
  GemResponse | undefined
> => {
  try {
    const gemResponse = (await walletGemsClient.getWalletGem()).data;
    return gemResponse;
  } catch (e) {
    return;
  }
};
